// =========================================================
// * Vue Material Dashboard PRO - v1.5.3
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vue-material-dashboard-pro
// * Copyright 2024 Creative Tim (https://www.creative-tim.com)
//
// * Coded by Creative Tim
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

import Vue from "vue";
import VueRouter from "vue-router";
import DashboardPlugin from "./material-dashboard";
import App from "./App.vue";
import Chartist from "chartist";
import store from "./storage/index.js";
import routes from "./routes/routes";

Vue.use(VueRouter);
Vue.use(DashboardPlugin);


// configure router
const router = new VueRouter({
  //mode: 'history',
  routes,
  scrollBehavior: (to) => {
    if (to.hash) {
      return { selector: to.hash, behavior: "smooth" };
    } else {
      return { x: 0, y: 0 };
    }
  },
  linkExactActiveClass: "nav-item active",
});

router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters.isAuthenticated;

  if (to.path === "/login" && isAuthenticated) {
    next("/infosite");
  } else if (to.matched.some((record) => record.meta.requiresAuth) && !isAuthenticated) {
    next("/login");
  } else {
    next();
  }
});

Vue.prototype.$Chartist = Chartist;
Vue.prototype.API_WS = "wss://backend.merito.tech/api2-ws";
Vue.prototype.API_R = "https://backend.merito.tech/api2-r";

new Vue({
  el: "#app",
  render: (h) => h(App),
  store,
  router,
});
